import { render, staticRenderFns } from "./infoBox.vue?vue&type=template&id=d2a0ba5e&"
import script from "./infoBox.vue?vue&type=script&lang=ts&"
export * from "./infoBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports